import type { StaticDataRouteOption } from "@tanstack/react-router"

import { SettingsNavigation } from "../SettingsNavigation/SettingsNavigation"
import { ProcedureTypeSettingsFieldsViewTopBar } from "./TopBar"

export const procedureTypeSettingsFieldsViewStaticData: StaticDataRouteOption = {
	leftSlideOut: SettingsNavigation,
	topBar: ProcedureTypeSettingsFieldsViewTopBar,
}
